module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="fileupload">\n    <div class="fileupload__dropzone"></div>\n\n    <div class="fileupload__filename">\n        <span class="fileupload__placeholder">' +
((__t = ( tv.placeholder )) == null ? '' : __t) +
'</span>\n        <span class="fileupload__name" filename></span>\n    </div>\n\n    <div class="fileupload__button fileupload__button--choose">\n        kies bestand...\n    </div>\n        \n    <div class="fileupload__button fileupload__button--delete" delete>\n        verwijderen\n    </div>\n    \n    <div class="fileupload__loader">\n        <span class="loader"></span>\n    </div>\n\n    <input type="hidden" name="' +
__e( tv.name ) +
'">\n</div>';

}
return __p
};
